import { render, staticRenderFns } from "./OaoCard.vue?vue&type=template&id=1fa0c491&scoped=true&functional=true"
import script from "./OaoCard.vue?vue&type=script&lang=js"
export * from "./OaoCard.vue?vue&type=script&lang=js"
import style0 from "./OaoCard.vue?vue&type=style&index=0&id=1fa0c491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1fa0c491",
  null
  
)

export default component.exports